import React from "react";

import "./Styles.css";

const CheckBox = ({ name, id, disabled = false, label, containerStyle = "container-text", ...props}) => {

    return (
        <div className="container-text">
            <label className="container-checkbox">
                <span className="checkbox-label">{label}</span>
                <input name={name} type="checkbox" disabled={disabled} id={id} {...props} />
                <span className="checkmark"></span>
            </label>
        </div>
    )
}

export default CheckBox